import { combineReducers } from '@reduxjs/toolkit';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import app from './app/reducer';
// import collections from './collections/reducer'
import flags from './flags/reducer';
import settings from './settings/reducer';
const AppReducer = combineReducers({
    app,
    flags,
    settings,
});
export const useAppDispatch = useDispatch;
export function useAppSelector(selectFn) {
    return useSelector(selectFn, shallowEqual);
}
export default AppReducer;
